module.exports = __webpack_public_path__ + "static/assets/6a9891055a39d4d618a170cf85891681.png";